var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStorefrom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5989",
    "data-name": "Group 5989",
    transform: "translate(-908 -401)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_329",
    "data-name": "Ellipse 329",
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(908 401)",
    fill: "#e8f1ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Route",
    transform: "translate(916 391.831)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7125",
    "data-name": "Path 7125",
    d: "M29.153,316H42.424A4.576,4.576,0,0,1,47,320.576h0a4.576,4.576,0,0,1-4.576,4.576H24.576A4.576,4.576,0,0,0,20,329.729h0a4.576,4.576,0,0,0,4.576,4.576H64.847",
    transform: "translate(0 -247.966)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5997",
    "data-name": "Group 5997",
    transform: "translate(25.015 56.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7126",
    "data-name": "Path 7126",
    d: "M63.945,213.564l.035.061Zm-.048-.082Zm.008.014.024.041Z",
    transform: "translate(-63.831 -213.366)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7127",
    "data-name": "Path 7127",
    d: "M65.256,215.832l-.011-.018Z",
    transform: "translate(-65.083 -215.534)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_342",
    "data-name": "Line 342",
    transform: "translate(29 45.169)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7128",
    "data-name": "Path 7128",
    d: "M33.118,56.59l3.966-6.867h0a9.152,9.152,0,1,0-15.863,0l3.966,6.867h0a4.578,4.578,0,0,0,7.931,0Z",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_343",
    "data-name": "Line 343",
    transform: "translate(65 63.169)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7129",
    "data-name": "Path 7129",
    d: "M345.118,216.59l3.966-6.867h0a9.152,9.152,0,1,0-15.863,0l3.966,6.867h0a4.578,4.578,0,0,0,7.931,0Z",
    transform: "translate(-276.305 -141.695)",
    fill: "none",
    stroke: "#0a64f9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStorefrom);
export default __webpack_public_path__ + "static/media/storefrom.77fe2e4d426f4bb5ad7b3db11a89cdae.svg";
export { ForwardRef as ReactComponent };